import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "side-menu-icon icon"
}
const _hoisted_2 = ["src"]

import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import SideMenuCardSection from "~/operatorApplication/vue/dialogs/dialog/sidemenu/SideMenuCardSection.vue";
import {Icon} from "~/cabinet/vue/interface/icon/IconInterface";


const __default__ = {
    name: "SideMenuInfo"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    icon: {},
    image: {},
    truncate: { type: Boolean },
    clickListening: { type: Boolean },
    bordered: { type: Boolean, default: true },
    compact: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {



let emits = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SideMenuCardSection, {
    class: "d-flex min-width-0",
    "click-listening": __props.clickListening,
    bordered: __props.bordered,
    compact: __props.compact,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(emits)('click')))
  }, {
    default: _withCtx(() => [
      (__props.icon || __props.image || _ctx.$slots.icon)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (__props.icon)
              ? (_openBlock(), _createBlock(FontAwesomeIcon, {
                  key: 0,
                  icon: __props.icon,
                  light: ""
                }, null, 8, ["icon"]))
              : (__props.image)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: __props.image
                  }, null, 8, _hoisted_2))
                : (_ctx.$slots.icon)
                  ? _renderSlot(_ctx.$slots, "icon", { key: 2 })
                  : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass({'flex-fill': true, 'text-truncate': __props.truncate})
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2)
    ]),
    _: 3
  }, 8, ["click-listening", "bordered", "compact"]))
}
}

})